/* eslint-disable no-lonely-if */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/*
 * Upload View
 *
 */
import {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {useUploads} from 'mars-uploader';
import Locale from '../util/Locale';
import './MarsUpload.scss';
import Util from '../util/Util';
import Analytics from '../util/Analytics';
import LoadingIndicator from './LoadingIndicator';
import FileUtils from '../util/FileUtils';
import {getAccountId} from '../util/ApiConfig';
import {useAssets} from '../Providers/AssetsProvider';

const videoTypes = [
    '.3g2',
    '.3gp',
    '.3gpp',
    '.asf',
    '.divx',
    '.dv',
    '.m1v',
    '.m2p',
    '.m2v',
    '.mov',
    '.moov',
    '.mpa',
    '.mpeg',
    '.mpv',
    '.ogm',
    '.omf',
    '.qt',
    '.rm',
    '.avi',
    '.wmv',
    '.flv',
    '.mpg',
    '.mp4'
];

const imageTypes = [
    'image/gif',
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/heic',
    'image/jfif',
    'image/bmp',
    'image/webp',
    '.swf',
    '.pdf'
];

export default function MarsUpload({
    title,
    setShowUpload,
    getSelectedPathForUploads,
    advertising = false,
    setShowFocused = () => {},
    hideDetailView = false,
    dropFiles = null,
    uploadLimit = 40
}) {
    const listRef = useRef(null);
    const {uploads, dispatchUploads} = useUploads();
    const [files, setFiles] = useState([]);
    const [overLimit, setOverLimit] = useState(false);
    const [complete, setComplete] = useState(false);
    const [current, setCurrent] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [filesInError, setFilesInError] = useState([]);
    const [renameErrors, setRenameErrors] = useState([]);
    const [validatingFiles, setValidatingFiles] = useState([]);
    const {pageDispatch} = useAssets();

    function fileUploadStatus(index) {
        const currentFile = files[index];
        if (currentFile) {
            const upload = uploads.list.find(a => a.uid === currentFile.uid);
            const error = uploads.errors.find(a => a.uid === currentFile.uid);
            return {upload, error};
        }
        return {};
    }

    function addUrlToFile(index, url) {
        const filez = [...files];
        filez[index].url = url;
        setFiles(filez);
    }

    function scrollTo(index) {
        if (listRef && listRef.current) {
            const entryHeight = document.querySelector('.filelist > .file-information')?.offsetHeight;
            if (entryHeight) {
                listRef.current.scrollTo({left: 0, top: entryHeight * index, behavior: 'smooth'});
            }
        } else {
            if (process.env.NODE_ENV !== 'test') {
                console.warn('listRef.current does not exist'); // eslint-disable-line
            }
        }
    }

    function getUnsupportedFileList() {
        const list = [];
        files.forEach((file, index) => {
            const {error} = fileUploadStatus(index);
            if (error && error.reason === 'UNSUPPORTED_FILE_TYPE') {
                list.push(file);
            }
        });
        return list;
    }

    useEffect(() => {
        dispatchUploads({type: 'CLEAR_ALL'});
    }, []); // eslint-disable-line

    const addFiles = async filez => {
        if (filez.length > uploadLimit) {
            setOverLimit(true);
        } else {
            setOverLimit(false);
            filez.forEach(file => {
                // Only assign UID if not already present (for test mocking)
                if (!file.uid) {
                    file.uid = Util.createUID();
                }
                file.originalName = file.name;
                const parentId = getAccountId();

                dispatchUploads({type: 'VALIDATE_ASSET', file, parentId, advertising});
            });

            setValidatingFiles(filez);
        }
    };

    useEffect(() => {
        if (dropFiles) {
            addFiles(dropFiles);
        }
    }, [dropFiles]); // eslint-disable-line

    const processValidationResults = () => {
        const validFiles = [];
        const errorFiles = [];

        validatingFiles.forEach(file => {
            // Check for errors in uploads.errors array
            const error = uploads.errors.find(a => a.uid === file.uid);

            if (error) {
                errorFiles.push({file, reason: error.reason, reasons: error.reasons});
            } else {
                // If no error, treat as valid
                validFiles.push(file);
            }
        });

        setFiles(validFiles);
        setFilesInError(errorFiles);
        setValidatingFiles([]);
    };

    useEffect(() => {
        if (!uploading && validatingFiles.length > 0 && uploads) {
            // Check if all files have completed validation
            // A file is validated when it's in errors OR in list with pending=false/validated=true
            const allValidated = validatingFiles.every(file => {
                const listItem = uploads.list.find(l => l.uid === file.uid);
                const errorItem = uploads.errors.find(e => e.uid === file.uid);

                // If in errors, it's validated (failed)
                if (errorItem) {
                    return true;
                }

                // If in list, check if validation is complete
                if (listItem) {
                    // Check for validation complete indicators
                    return listItem.validated === true || listItem.pending === false;
                }

                return false;
            });

            if (allValidated) {
                processValidationResults();
            }
        }
    }, [uploads, validatingFiles, uploading]); // eslint-disable-line

    useEffect(() => {
        if (uploading && uploads && (uploads.list.length || uploads.errors.length)) {
            const {upload, error} = fileUploadStatus(current);
            if (upload || error) {
                if (upload && !upload.pending) {
                    if (!upload.file.url && upload?.assetInfo?.name) {
                        addUrlToFile(current, upload.assetInfo.name);
                    }
                    pageDispatch({type: 'UPDATE_ASSETS', command: 'ADD', assets: [upload.assetInfo]});
                }
                if (error || (upload && !upload.pending)) {
                    const next = current + 1;
                    if (next < files.length) {
                        setCurrent(next);
                        const parentId = getAccountId();
                        dispatchUploads({type: 'UPLOAD_IMAGE', file: files[next], parentId, advertising}); // Next up...
                        scrollTo(next);
                    } else {
                        setUploading(false);
                        setComplete(true);
                    }
                }
            }
        }
    }, [uploads, files, current, advertising]); // eslint-disable-line

    const addFilesFromEvent = async event => {
        const filez = Array.from('dataTransfer' in event ? event.dataTransfer.files : event.currentTarget.files);
        addFiles(filez);
    };

    const adjustFilename = (f, newFilename) => {
        const newFile = new File([f], newFilename, {
            type: f.type,
            lastModified: f.lastModified
        });
        newFile.uid = f.uid;
        newFile.originalName = f.originalName;
        return newFile;
    };

    const renameFile = (index, newFilename) => {
        const filez = [...files];
        const f = adjustFilename(filez[index], newFilename);
        filez[index] = f;
        setFiles(filez);
    };

    const harmonizeFilename = f => {
        let newName = '';
        let fname = f.name;
        const {originalName} = f;
        if (fname && originalName && fname !== originalName) {
            const fileExtension = Util.getFileExtension(fname);
            const ofe = Util.getFileExtension(originalName);
            if (fileExtension !== ofe) {
                fname = fname.trim();
                const lastPeriodIdx = fname.lastIndexOf('.');
                if (lastPeriodIdx > -1) {
                    fname = fname.substr(0, lastPeriodIdx);
                }
                newName = `${fname}.${ofe}`;
                return adjustFilename(f, newName);
            }
        }
        return f;
    };

    const adjustFilesForUploading = () => {
        const filez = [...files].reverse(); // Reverse order so that matches expected order with default sort on Newest
        filez.forEach((f, index) => {
            const newFile = harmonizeFilename(f);
            if (f !== newFile) {
                filez[index] = newFile;
            }
        });
        setFiles(filez);
        return filez;
    };

    const uploadFiles = () => {
        if (!uploading) {
            const libraryId = getSelectedPathForUploads();
            const parentId = getAccountId();

            if (parentId && libraryId) {
                Util.setUploaderLibraryId(libraryId); // Tell mars-uploader which libraryId to use
                // Clear validation results from uploads.list before starting actual uploads
                dispatchUploads({type: 'CLEAR_ALL'});
                setUploading(true);
                const filez = adjustFilesForUploading();
                setCurrent(0);
                dispatchUploads({type: 'UPLOAD_IMAGE', file: filez[0], parentId, advertising}); // Start the ball rolling...
                scrollTo(0);
            } else {
                if (process.env.NODE_ENV !== 'test') {
                    console.warn('TODO: No libraryId to upload too!'); // eslint-disable-line
                }
            }
        }

        if (current < files.length) {
            setUploading(true);
            harmonizeFilename(current);
        }

        if (files[current].originalName) {
            const asset = files[current];
            Analytics.trackEvent('Upload Asset Renamed', `${asset.originalName} to ${asset.name}`);
        }
    };

    const onDragEvent = event => {
        event.preventDefault();
        event.stopPropagation();
    };

    const onImageDrop = event => {
        Analytics.trackEvent('Asset', 'Upload (Modal drop)');
        onDragEvent(event);
        addFilesFromEvent(event);
    };

    // eslint-disable-next-line arrow-body-style
    const onFilenameChange = index => {
        return event => {
            const renameErrorz = [...renameErrors];
            const filename = event.target?.value?.trim();
            renameErrorz[index] = filename !== null && filename.length === 0 ? Locale.getText('RENAME_NOT_EMPTY') : '';

            if (!renameErrorz[index]) {
                renameFile(index, filename);
            }
            setRenameErrors(renameErrorz);
        };
    };

    const clearImageData = () => {
        if (document.getElementById('files')) {
            document.getElementById('files').value = null;
        }
        dispatchUploads({type: 'CLEAR_ALL'});
        setFiles([]);
        setFilesInError([]);
        setValidatingFiles([]);
    };

    const renderErroredFiles = () => {
        if (filesInError) {
            return (
                <>
                    <div className="file-header">
                        <div>{Locale.getText('ERROR_HEADER')}</div>
                    </div>
                    <div className="filelist-wrapper" ref={listRef}>
                        <ul className="error-list">
                            {filesInError.map(item => {
                                let errorMessage = null;
                                if (item.reasons) {
                                    errorMessage = FileUtils.buildUploadFileErrorMessage(item.reasons);
                                } else if (item.reason) {
                                    errorMessage = `${Locale.getText('INVALID')} ${Locale.getText(item.reason)}`;
                                }

                                return (
                                    <li key={`error-${item.file.uid}`} id={`error-${item.file.uid}`}>
                                        <span className="error-icon">
                                            <svg
                                                fill="none"
                                                height="16"
                                                stroke="#CC4331"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
                                                <line x1="12" x2="12" y1="8" y2="12" />
                                                <line x1="12" x2="12" y1="16" y2="16" />
                                            </svg>
                                        </span>
                                        {item.file.name}
                                        {errorMessage && <span className="error-reason">{` - ${errorMessage}`}</span>}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </>
            );
        }
        return null;
    };

    const renderDropzone = () => {
        const acceptList = advertising ? '.mp4' : `${imageTypes.join(',')},${videoTypes.join(',')}`;
        return (
            <div className="dropzone" onDragEnter={onDragEvent} onDragOver={onDragEvent} onDrop={onImageDrop}>
                <span>{Locale.getText('DRAG_MEDIA')}</span>
                <div className="separator">
                    <span>or</span>
                </div>
                <input multiple type="file" id="files" name="file" accept={acceptList} onChange={addFilesFromEvent} />
                <label htmlFor="files">
                    <nsemble-button
                        onClick={() => {
                            Analytics.trackEvent('Asset', 'Upload (Browse)');
                        }}
                        text
                    >
                        {Locale.getText('BROWSE')}
                    </nsemble-button>
                </label>
            </div>
        );
    };

    const uploadRequestIcon = () => (
        // Upload request icon
        <svg
            fill="none"
            height="16"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polyline points="16 16 12 12 8 16" />
            <line x1="12" x2="12" y1="12" y2="21" />
            <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
            <polyline points="16 16 12 12 8 16" />
        </svg>
    );

    const renderIcon = index => {
        if (uploading || complete) {
            const {upload, error} = fileUploadStatus(index);
            if (error) {
                // Error icon
                return (
                    <svg
                        fill="none"
                        height="16"
                        stroke="#CC4331"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
                        <line x1="12" x2="12" y1="8" y2="12" />
                        <line x1="12" x2="12" y1="16" y2="16" />
                    </svg>
                );
            }
            if (upload) {
                if (upload.pending) {
                    return uploadRequestIcon();
                }
                // Checkmark icon
                return (
                    <svg
                        fill="none"
                        height="16"
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                );
            }
            return uploadRequestIcon();
        }

        // Cancel icon
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <g
                    className="nc-icon-wrapper"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    fill="#72BF36"
                    stroke="#72BF36"
                >
                    <line fill="none" stroke="#000000" strokeMiterlimit="10" x1="16" y1="8" x2="8" y2="16" />
                    <line fill="none" stroke="#000000" strokeMiterlimit="10" x1="16" y1="16" x2="8" y2="8" />
                </g>
            </svg>
        );
    };

    const removeFile = index => {
        const filez = files.slice(0);

        if (filez[index]) {
            filez.splice(index, 1);
            setFiles(filez);
        }
    };

    const renderFileAction = index => {
        if (uploading || complete) {
            if (uploading && index === current) {
                return <div className="file-status current">{renderIcon(index)}</div>;
            }
            return <div className="file-status">{renderIcon(index)}</div>;
        }
        return (
            <div>
                <div className="remove-file" onClick={() => !complete && removeFile(index)}>
                    {renderIcon(index)}
                </div>
            </div>
        );
    };

    // This function allows only one file in files to indicate that is has been 'copied'
    const updateFileCopyStatus = idx => {
        const filez = [...files];
        filez.forEach((file, i) => {
            file.copied = i === idx;
        });
        setFiles(filez);
    };

    const renderCopyAssetButton = index => (
        <nsemble-button
            class={files[index].copied ? 'item-copied' : 'upload-item-copy'}
            text
            title={Locale.getText('COPY_LINK_ASSET')}
            onClick={() => {
                Util.copyToClipboard(
                    files[index],
                    () => {
                        updateFileCopyStatus(index);
                    },
                    true
                );
            }}
        />
    );

    const renderFailedProgress = index => {
        const {error} = fileUploadStatus(index);
        if (error && error.reason !== 'UNSUPPORTED_FILE_TYPE') {
            const errors = FileUtils.buildUploadFileErrorMessage(error.reasons);
            return <div className="error-message">{errors || Locale.getText('ERROR_MESSAGE')}</div>;
        }
        return null;
    };

    const renderFileInfo = () =>
        files.map((file, index) => {
            const otherProps = uploading || complete ? {disabled: true} : {};
            if (renameErrors[index]) {
                otherProps.error = renameErrors[index];
            }
            const {upload} = fileUploadStatus(index);
            return (
                <li className="file-information" key={file.uid} id={file.uid}>
                    <div className="file-description">
                        {renderFileAction(index)}
                        <span className="filename">
                            <nsemble-input value={file.name} {...otherProps} onInput={onFilenameChange(index)} />
                        </span>
                        <span className="filesize">{Util.byteSizeString(file.size)}</span>
                        {complete &&
                            upload &&
                            Util.getFileTypeLabelFromMimeType(file.type, file) !== 'VIDEO' &&
                            renderCopyAssetButton(index)}
                    </div>
                    <div>{complete && renderFailedProgress(index)}</div>
                </li>
            );
        });

    const renderFileList = () => (
        <div className="files">
            <div className="file-header">
                <div>{Locale.getText('UPLOAD_RENAME_MESSAGE')}</div>
                <div className="file-number">{files.length} File(s)</div>
            </div>
            <div className="filelist-wrapper" ref={listRef}>
                <ul className="filelist">{renderFileInfo()}</ul>
            </div>
        </div>
    );

    const renderFileError = file => (
        <li key={`error-${file.uid}`} id={`error-${file.uid}`}>
            {file.name}
        </li>
    );

    const renderFileErrors = () => (
        <div className="file-errors">
            <div className="error-list-message">{Locale.getText('FILE_ERROR')}</div>
            <ul className="error-list">{getUnsupportedFileList().map(file => renderFileError(file))}</ul>
        </div>
    );

    const renderFileFormats = () => {
        if (advertising) {
            return <div className="upload-suggestions">{Locale.getText('ADV_VIDEO_REQUIREMENTS')}</div>;
        }
        return <div className="upload-suggestions">{Locale.getText('ERROR_SUGGESTIONS')}</div>;
    };

    const renderValidationOverlay = () => {
        return (
            <div className="validating-files">
                <LoadingIndicator isLoading>
                    <div className="validation-message">{Locale.getText('VALIDATING_FILES')}</div>
                </LoadingIndicator>
            </div>
        );
    };

    const renderUploadResults = () => {
        const successCount = uploads.list.length;
        const errorCount = uploads.errors.length;

        return (
            <div>
                <div className="successful-upload">{`${successCount} ${Locale.getText('UPLOAD_SUCCESS')}`}</div>{' '}
                {errorCount > 0 && <div>{`${errorCount} ${Locale.getText('UPLOAD_FAILURE')}`}</div>}
            </div>
        );
    };

    const renderStatusMessage = () => {
        if (complete && uploads.errors.length === 0) {
            return (
                <div className="upload-success">
                    <span className="message">{renderUploadResults()}</span>
                </div>
            );
        }
        return '';
    };

    const renderActions = () => {
        if (complete) {
            return (
                <div id="modal-footer">
                    <div className="upload-actions">
                        <div className="actions-right">
                            <nsemble-button
                                text
                                onClick={() => {
                                    setShowUpload(false);
                                    if (hideDetailView) {
                                        setShowFocused(null);
                                    }
                                }}
                            >
                                {Locale.getText('CLOSE')}
                            </nsemble-button>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div id="modal-footer">
                <div className="upload-actions">
                    <nsemble-button
                        text
                        {...((files.length > 0 && !uploading) || uploads.errors.length ? {} : {disabled: true})}
                        onClick={() => clearImageData()}
                    >
                        {uploads.errors.length ? Locale.getText('TRY_AGAIN') : Locale.getText('CLEAR')}
                    </nsemble-button>
                    <div className="actions-right">
                        <nsemble-button
                            text
                            {...(!uploading || uploads.errors.length ? {} : {disabled: true})}
                            onClick={() => {
                                setShowUpload(false);
                            }}
                        >
                            {Locale.getText('CANCEL')}
                        </nsemble-button>
                        <LoadingIndicator isLoading={uploading && !complete}>
                            <nsemble-button
                                text
                                {...(files.length > 0 && !uploading && !renameErrors.some(val => Boolean(val))
                                    ? {}
                                    : {disabled: true})}
                                onClick={() => {
                                    uploadFiles();
                                    Analytics.trackEvent(files.length > 1 ? 'Asset(s)' : 'Asset', 'Upload (Confirm)');
                                }}
                            >
                                {Locale.getText('UPLOAD_MEDIA')}
                            </nsemble-button>
                        </LoadingIndicator>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div id="modal-header">
                <h1>{title}</h1>
            </div>
            <div id="modal-body">
                {validatingFiles.length > 0 &&
                    files.length === 0 &&
                    filesInError.length === 0 &&
                    renderValidationOverlay()}
                {files.length === 0 && filesInError.length === 0 && validatingFiles.length === 0 && renderDropzone()}
                {overLimit && <div className="over-limit">{Locale.getText('OVER_LIMIT', {uploadLimit})}</div>}
                {files.length === 0 &&
                    filesInError.length === 0 &&
                    validatingFiles.length === 0 &&
                    FileUtils.getRoutingKey() !== 'test' &&
                    renderFileFormats()}
                {filesInError.length > 0 && renderErroredFiles()}
                {files.length > 0 && renderFileList()}
                {getUnsupportedFileList().length > 0 && renderFileErrors()}
                {renderStatusMessage()}
                {complete && uploads.errors.length > 0 && renderFileFormats()}
            </div>
            {renderActions()}
        </div>
    );
}

MarsUpload.propTypes = {
    title: PropTypes.string.isRequired,
    setShowUpload: PropTypes.func.isRequired,
    getSelectedPathForUploads: PropTypes.func.isRequired,
    advertising: PropTypes.bool,
    setShowFocused: PropTypes.func,
    hideDetailView: PropTypes.bool,
    dropFiles: PropTypes.arrayOf(PropTypes.any),
    uploadLimit: PropTypes.number
};
